import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { AdsPage } from "../enums/ad-page";
import { usePathname } from "next/navigation";
import { usePageType } from "@/hooks/usePageType";
import { trackClickAds } from "../util/functions";

const getAdsPageByPathName = (path: string): AdsPage => {
	if (path.includes("/games")) {
		return AdsPage.GAME_PAGE;
	} else if (path.includes("/movies")) {
		return AdsPage.MOVIE_PAGE;
	} else if (path.includes("/series")) {
		return AdsPage.SERIES_PAGE;
	} else if (path.includes("/board-games")) {
		return AdsPage.BOARD_GAME_PAGE;
	} else if (path.includes("/news")) {
		return AdsPage.NEWS_PAGE;
	} else {
		return AdsPage.MAIN_PAGE;
	}
};

export default function AdComponent() {
	const [showAd, setShowAd] = useState(true);

	const pathname = usePathname();
	const [ad, setAd] = useState<any>(null);
	useEffect(() => {
		const fetchAd = async () => {
			try {
				const adsPage = getAdsPageByPathName(pathname);
				const res = await fetch(`/api/ads?adsPage=${adsPage}`);
				const body = await res.json();
				if (body && body.content && body.content.length > 0) {
					setAd(body?.content[0]);
				} else {
					setAd(null);
				}
			} catch (err) {
				console.error("Failed to fetch ads:", err);
			}
		};

		fetchAd();
	}, [pathname]);
	const pageType = usePageType();

	if (!ad || !showAd) return null;

	return (
		<div className="relative w-full h-[120px]">
			{/* Close Button */}
			<button
				onClick={() => setShowAd(false)}
				className="absolute top-1 right-1 z-10 bg-white/80 hover:bg-white text-gray-600 rounded-full p-1 shadow"
			>
				<FaTimes className="w-3 h-3" />
			</button>

			{/* Ad Link + Image */}
			<Link
				className="w-full h-full block"
				href={ad.link}
				onClick={() => trackClickAds(ad.id, pageType)}
				target="_blank"
				rel="nofollow noopener"
			>
				<Image
					src={process.env.NEXT_PUBLIC_FILE_URL + ad?.file?.code}
					alt={ad?.title}
					layout="fill"
					objectFit="contain"
				/>
			</Link>
		</div>
	);
}
